import { Button, Form, FormControl, FormLabel, Textarea, useToast } from '@homebotapp/hb-react-component-catalog'
import { useState } from 'react'
import { useScheduleTourStep } from '../../../../../../../../hooks/useScheduleTourStep'
import { useVerificationFlow } from '../../../../../../../shared/VerificationFlow'
import { defineMessages, useIntl } from 'react-intl'
import { Listing } from '../../../../../../../../api/gqlaxy/gql/generated/graphql'

type FormValues = {
  message: string
}

const MSG = defineMessages({
  defaultMessage: {
    id: 'ScheduleTour.VerificationFlow.SendMessageView.defaultMessage',
    defaultMessage: 'I would like to learn more about this listing.'
  },
  error: {
    id: 'SendMessageView.error',
    defaultMessage: 'Failed to send message. Please try again.'
  },
  label: {
    id: 'ScheduleTour.VerificationFlow.SendMessageView.label',
    defaultMessage: 'Do you have anything you would like to add to your request?'
  },
  nextStep: {
    id: 'ScheduleTour.VerificationFlow.SendMessageView.nextStep',
    defaultMessage: 'Next step'
  }
})

/**
 * Send message view specifically for the Schedule A Tour verification flow
 *
 * @param listing - The listing to schedule a tour for
 * @returns SendMessageView
 */
export const SendMessageView = ({ listing }: { listing: Listing }) => {
  const intl = useIntl()
  const { scheduleTour } = useScheduleTourStep({ listing })
  const { dispatch } = useVerificationFlow()
  const toast = useToast()
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async (vals: FormValues) => {
    try {
      await scheduleTour(vals.message)
      dispatch({ type: 'MESSAGE_SUCCESS' })
    } catch (error) {
      toast({
        description: intl.formatMessage(MSG.error),
        status: 'error'
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Form
      onSubmit={onSubmit}
      display='flex'
      flexDirection='column'
      justifyContent='space-between'
      h='100%'
      flex={1}
      pb='4.5em'
      defaultValues={{
        message: intl.formatMessage(MSG.defaultMessage)
      }}
    >
      <FormControl>
        <FormLabel size='lg' mb='4'>
          {intl.formatMessage(MSG.label)}
        </FormLabel>
        <Textarea
          name='message'
          tracking={{
            guid: 'qvTPVX39kVbnNE8EN8oNR2',
            ui_context: 'schedule_tour_verification_flow_send_message_view',
            descriptor: MSG.label.defaultMessage
          }}
        />
      </FormControl>
      <Button
        colorScheme='primary'
        type='submit'
        isLoading={isLoading}
        tracking={{
          guid: 'xjqvH3dq358dwmrWmV3HWa',
          ui_context: 'schedule_tour_verification_flow_send_message_view',
          descriptor: MSG.nextStep.defaultMessage
        }}
      >
        {intl.formatMessage(MSG.nextStep)}
      </Button>
    </Form>
  )
}
